import React from 'react';
import { Button } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { useAppSelector } from '../../../../../app/store';
import { useDownloadCarveOutsMutation } from '../../../../../services/ContractService';

interface CarveOutDownloadCsvProps {
  disabled?: boolean;
}

const CarveOutDownloadCsv: React.FC<CarveOutDownloadCsvProps> = ({ disabled = false }) => {
  const selectedContract = useAppSelector((state) => state.contract.currentContract);
  const [downloadCarveOuts, { isLoading: isDownloading }] = useDownloadCarveOutsMutation();

  const handleDownload = async () => {
    if (!selectedContract?.id) {
      console.warn('No contract selected');
      return;
    }
    
    try {
      const blob = await downloadCarveOuts({
        contractId: selectedContract.id
      }).unwrap();
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `CarveOuts_Contract_${selectedContract.id}_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
    }
  };

  const isDisabled = disabled || !selectedContract?.id || isDownloading;

  return (
    <Button
      variant="outlined"
      startIcon={<DownloadIcon />}
      onClick={handleDownload}
      size="small"
      disabled={isDisabled}
    >
      Download CSV
    </Button>
  );
};

export default CarveOutDownloadCsv;